export default () => {
	const $placeholder = $("select");
	if ($placeholder.length) {
		$placeholder.each(function() {
			const $this = $(this);

			// Initial
			$this.addClass("placeholder-shown");
			$this.children(".gf_placeholder").attr("disabled", true);

			// Change
			$this.on("change", (event) => {
				const $this = $(event.currentTarget);
				if ($this.val()) {
					$this.removeClass("placeholder-shown").addClass("placeholder-hidden");
				} else {
					$this.addClass("placeholder-shown").removeClass("placeholder-hidden");
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/select-placeholder.js